import type { CSSProperties, ReactNode } from 'react';
import { colors, inputStyle, lavenderButtonStyle, primaryButtonStyle } from '../lib/theme';

export const authFormStyle: CSSProperties = { display: 'flex', flexDirection: 'column', gap: '0.9rem' };
export const authFieldStyle: CSSProperties = { ...inputStyle, width: '100%', boxSizing: 'border-box', padding: '0.65rem 0.9rem' };
export const authSubmitStyle: CSSProperties = { ...primaryButtonStyle, width: '100%', padding: '0.7rem 1.1rem', fontSize: '1rem' };
export const authSecondaryStyle: CSSProperties = {
  ...lavenderButtonStyle,
  display: 'block',
  width: '100%',
  boxSizing: 'border-box',
  padding: '0.7rem 1.1rem',
  textAlign: 'center',
  textDecoration: 'none',
  fontSize: '1rem',
};
export const authErrorStyle: CSSProperties = {
  margin: 0,
  background: colors.red,
  color: colors.redText,
  borderRadius: 12,
  padding: '0.5rem 0.75rem',
  fontSize: '0.9rem',
  fontWeight: 600,
};

interface Props {
  title: string;
  children: ReactNode;
}

/** Centered card shared by the login, signup and password-reset pages. */
export default function AuthLayout({ title, children }: Props) {
  return (
    <div
      style={{
        minHeight: 'calc(100vh - 160px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 400,
          boxSizing: 'border-box',
          background: '#fff',
          borderRadius: 24,
          padding: '1.75rem 1.5rem',
          boxShadow: '0 6px 24px rgba(0,0,0,0.08)',
        }}
      >
        <h2 style={{ margin: '0 0 1.25rem', textAlign: 'center' }}>{title}</h2>
        {children}
      </div>
    </div>
  );
}
